import React, { useContext, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ProtectedRouteToJobs from '../utils/ProtectedRouteJobs';
import Jobs from './Sections/Jobs';
import AuthorizationOfPersonalDataCV from './Sections/AuthorizationOfPersonalDataCV';
import PageNotFound from '../layout/PageNotFound';
import SelectPrivacyPolicy from '../layout/cookiesConsent/SelectPrivacyPolicy';
import '../stylesheets/muggle.scss';
import '../stylesheets/App.scss';
import routes from '../utils/commonVariables/routes';
import { ContextGlobalFeatures } from '../contexts/GlobalFeatures';

const ExternalPagesContainer = props => {
    const { setIsExternalPage } = useContext(ContextGlobalFeatures);
    // páginas que se visitan desde fastpayhotels.com y no desde el portal del propietario
    // no se muestran menús de navegación ni footer
    useEffect(() => {
        setIsExternalPage(true);
        return () => {
            setIsExternalPage(false);
        };
    }, [setIsExternalPage]);

    return (
        <main className='flex flex-grow'>
            <Switch>
                <ProtectedRouteToJobs path='/jobs' render={() => <Jobs />} />
                <Route
                    path='/authorization-personal-data'
                    render={() => <AuthorizationOfPersonalDataCV {...props} />}
                />
                <Route
                    path={routes.privacyPolicy}
                    component={SelectPrivacyPolicy}
                />
                <Route path='/not-found' component={PageNotFound} />
                <Route
                    path='/'
                    exact
                    render={() => <main className='muggleContainer' />}
                >
                    <Redirect to='/owner-portal' />
                </Route>
                <Redirect to='/not-found' />
            </Switch>
        </main>
    );
};

export default ExternalPagesContainer;
